module.exports = __webpack_public_path__ + "img/fabio.3bdbe95c.png";